import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import WSelect from "@/components/form/w-select.vue";
import VoiceSelectorModal from "@/components/aiSpeachGenerator/VoiceSelectorModal.vue";
import { ContentMode } from "@/models/ai/enum/aiContentMode.enum";
import { AIAvatar } from "@/models/ai/enum/aiAvatar.enum";
import { AIBackground } from "@/models/ai/enum/aiBackground.enum";
import { AIAvatarGender } from "@/models/ai/enum/aiAvatarGender.enum";
import { LIST_OF_BACKGROUND, LIST_OF_VOICES, getAvatarEntry, getBackgroundEntry, getAvatarThumbnailUrl, getAvatarAnimUrl, isCustomAvatarAllowed, getAvailableAvatars, getVoiceEntry, getDefaultAvatarForGender } from "@/models/ai/aiAvatarReferential.model";
import { LIST_OF_IMAGE_STYLES } from "@/models/ai/aiImageStyle.model";
import { LIST_OF_VISUAL_TEMPLATES } from "@/models/ai/aiVisualTemplate.model";
import WInput from "@/components/form/w-input.vue";
import WCheckbox from "@/components/form/w-checkbox.vue";
import { SlideGenerationMode } from "@/util/generationModeEnum";
import AiCreditsToolTip from "@/components/tooltip/AiCreditsToolTip.vue";
const LS_PREFIX = "speach.ai.style.";
let AIStyleStep = class AIStyleStep extends Vue {
  constructor(...args) {
    super(...args);
    /** Whether advanced (Gemini) TTS voices are enabled for this platform (ENABLE_ADVANCED_TTS). */
    _defineProperty(this, "advancedTtsEnabled", void 0);
    /** Content mode === drives which style blocks are shown. Chosen via the mode cards on this screen. */
    _defineProperty(this, "contentMode", void 0);
    _defineProperty(this, "generationMode", void 0);
    _defineProperty(this, "duration", void 0);
    _defineProperty(this, "specificPrompt", void 0);
    _defineProperty(this, "allowReorder", void 0);
    // AI_AVATAR_CUSTOM allow-list (e.g. "ANDY;MORGAN"): custom avatars (Dana, Andy...) are only
    // offered when their name is in this list. Mirrors the weet recorder's avatar picker.
    _defineProperty(this, "avatarCustom", void 0);
    _defineProperty(this, "durationSelected", "");
    _defineProperty(this, "listOfDuration", []);
    _defineProperty(this, "useAvatar", false);
    _defineProperty(this, "selectedAvatar", AIAvatar.MARIE);
    _defineProperty(this, "selectedBackground", AIBackground.WHITE);
    _defineProperty(this, "selectedVoice", LIST_OF_VOICES[0].voice);
    // Voice preview (play a pre-rendered sample of the selected voice).
    _defineProperty(this, "previewPlaying", false);
    _defineProperty(this, "previewAudio", null);
    // Voice picker modal (filters + per-voice previews live in VoiceSelectorModal).
    _defineProperty(this, "voiceModalOpen", false);
    _defineProperty(this, "selectedImageStyle", LIST_OF_IMAGE_STYLES[0].value);
    _defineProperty(this, "selectedTemplateKey", LIST_OF_VISUAL_TEMPLATES[0].key);
    _defineProperty(this, "quizEnabled", true);
    // Default OFF on the generation UI: the user opts in to automatic annotations.
    // (Legacy speachs without the field still default to true downstream.)
    _defineProperty(this, "annotationsEnabled", false);
    _defineProperty(this, "isPlayingAnim", false);
  }
  get visualTemplates() {
    return LIST_OF_VISUAL_TEMPLATES;
  }
  // === Generation mode (4 cards) ===
  get isPreserveDocument() {
    return this.generationMode === SlideGenerationMode.STRICT;
  }
  /** The selected card, derived from the content + generation modes. */
  get selectedLayout() {
    if (this.generationMode === SlideGenerationMode.STRICT) return 'PRESERVE_DOCUMENT';
    if (this.contentMode === ContentMode.FULL_EXPLAINER) return 'VIDEO_EXPLAINER';
    return this.contentMode;
  }
  get modeCards() {
    return [{
      value: 'FULL_SLIDE',
      icon: "image-multiple-outline",
      title: this.$t('aiSpeachGenerator.styleStep.mode.fullSlideTitle'),
      desc: this.$t('aiSpeachGenerator.styleStep.mode.fullSlideDesc')
    }, {
      value: 'MIXED',
      icon: "layers-outline",
      title: this.$t('aiSpeachGenerator.styleStep.mode.mixedTitle'),
      desc: this.$t('aiSpeachGenerator.styleStep.mode.mixedDesc')
    }, {
      value: 'VIDEO_EXPLAINER',
      icon: "movie-open-outline",
      title: this.$t('aiSpeachGenerator.styleStep.mode.fullExplainerTitle'),
      desc: this.$t('aiSpeachGenerator.styleStep.mode.fullExplainerDesc')
    }, {
      value: 'PRESERVE_DOCUMENT',
      icon: "file-document-outline",
      title: this.$t('aiSpeachGenerator.styleStep.mode.preserveDocumentTitle'),
      desc: this.$t('aiSpeachGenerator.styleStep.mode.preserveDocumentDesc')
    }];
  }
  onSelectMode(layout) {
    let contentMode = ContentMode.FULL_SLIDE;
    let genMode = SlideGenerationMode.ENHANCED;
    switch (layout) {
      case 'FULL_SLIDE':
        contentMode = ContentMode.FULL_SLIDE;
        genMode = SlideGenerationMode.ENHANCED;
        break;
      case 'MIXED':
        contentMode = ContentMode.MIXED;
        genMode = SlideGenerationMode.ENHANCED;
        break;
      case 'VIDEO_EXPLAINER':
        contentMode = ContentMode.FULL_EXPLAINER;
        genMode = SlideGenerationMode.ENHANCED;
        break;
      case 'PRESERVE_DOCUMENT':
        contentMode = ContentMode.FULL_SLIDE;
        genMode = SlideGenerationMode.STRICT;
        break;
    }
    this.$emit('contentMode', contentMode);
    this.$emit('generationMode', genMode);
  }
  onDurationSelected(value) {
    this.$emit('durationChange', value);
  }
  onSpecificPromptChange(value) {
    this.$emit('specificPrompt', value);
  }
  onAllowReorderChange(value) {
    this.$emit('allowReorder', value);
  }
  // Avatar + Image Style are available in the slide-based modes.
  get showAvatarBlock() {
    return this.contentMode === ContentMode.FULL_SLIDE || this.contentMode === ContentMode.MIXED;
  }
  get showImageStyleBlock() {
    // Hidden as soon as the video explainer is active (MIXED / Full Explainer): explainer
    // subchapters use the template's own image style, so the global picker is not shown then.
    return (this.contentMode === ContentMode.FULL_SLIDE || this.contentMode === ContentMode.MIXED) && !this.showExplainerBlock;
  }
  // Standalone voice panel === shown whenever no avatar is active: in Full Video
  // Explainer (no avatar block at all) AND when the avatar toggle is off in the
  // slide-based modes. Same panel in both cases.
  get showVoiceOnlyBlock() {
    return !this.isAvatarActive;
  }
  // Video explainer template picker === shown (and required) in the explainer modes.
  get showExplainerBlock() {
    return this.contentMode === ContentMode.MIXED || this.contentMode === ContentMode.FULL_EXPLAINER;
  }
  // The content mode is chosen on the Options step and passed in as a prop. When
  // it changes, keep the selected voice valid for the new mode and stop the
  // avatar preview when switching to voice-only Full Video Explainer.
  onContentModeChanged(mode) {
    this.ensureVoiceMatchesFilter();
    if (mode === ContentMode.FULL_EXPLAINER) {
      this.stopAnim();
    }
  }
  // === Dropdown options ===
  get avatarOptions() {
    // The avatar picker is NEVER filtered by gender — all available avatars are always shown
    // (custom allow-list aside). Gender coherence goes the other way: an active avatar filters
    // the voice list; with no avatar the voice drives the avatar's gender.
    return getAvailableAvatars(this.avatarCustom).map(a => {
      const inner = `<img src="${getAvatarThumbnailUrl(a.avatar)}" class="dropdownThumb" alt="${a.label}"/><span class="dropdownLabel">${a.label}</span>`;
      return {
        value: a.avatar,
        label: a.label,
        htmlContent: `<div class="dropdownRow">${inner}</div>`,
        htmlLabel: `<div class="dropdownRow">${inner}</div>`
      };
    });
  }
  get backgroundOptions() {
    return LIST_OF_BACKGROUND.map(b => {
      const inner = `<img src="${b.url}" class="dropdownThumb" alt="${b.label}"/><span class="dropdownLabel">${b.label}</span>`;
      return {
        value: b.background,
        label: b.label,
        htmlContent: `<div class="dropdownRow">${inner}</div>`,
        htmlLabel: `<div class="dropdownRow">${inner}</div>`
      };
    });
  }
  /** True when an avatar is actually used (slide modes + avatar toggle on). */
  get isAvatarActive() {
    return this.showAvatarBlock && this.useAvatar;
  }
  /**
   * Voices available in the picker:
   * - Avatar active → filtered to the avatar's gender only (the avatar drives the voice).
   * - No avatar → all voices (only advanced-TTS gating); the voice then drives the avatar's gender.
   * Advanced TTS enabled → advanced (Gemini) voices only; otherwise standard voices as a fallback.
   */
  get compatibleVoices() {
    let voices = LIST_OF_VOICES.filter(v => !!v.advanced === this.advancedTtsEnabled);
    if (this.isAvatarActive) {
      const g = getAvatarEntry(this.selectedAvatar)?.gender;
      if (g === AIAvatarGender.MALE || g === AIAvatarGender.FEMALE) {
        voices = voices.filter(v => v.gender === g);
      }
    }
    return voices;
  }
  /** Label of the currently-selected voice (shown on the picker trigger). */
  get selectedVoiceLabel() {
    const v = LIST_OF_VOICES.find(vv => vv.voice === this.selectedVoice);
    return v ? v.label : '';
  }
  /** Single-option list so the voice field renders like the other w-selects. */
  get voiceDisplayOptions() {
    return [{
      value: this.selectedVoice,
      label: this.selectedVoiceLabel
    }];
  }
  /** Gender lock for the voice modal: the avatar's gender when an avatar is active, free otherwise. */
  get voiceModalGender() {
    if (!this.isAvatarActive) return '';
    const g = getAvatarEntry(this.selectedAvatar)?.gender;
    return g === AIAvatarGender.MALE || g === AIAvatarGender.FEMALE ? g : '';
  }
  openVoiceModal() {
    this.stopVoicePreview();
    this.voiceModalOpen = true;
  }
  onVoiceModalValidate(payload) {
    this.voiceModalOpen = false;
    if (payload && payload.voice) {
      this.onVoiceChange(payload.voice);
    }
  }
  get imageStyleOptions() {
    return LIST_OF_IMAGE_STYLES.map(s => ({
      value: s.value,
      label: s.label
    }));
  }
  /**
   * Reset the selected voice to the first available in the filtered list
   * if the current one doesn't match anymore. Called on avatar change /
   * switch toggle / mount.
   */
  /**
   * The voice to start from / fall back to: the first ADVANCED (Gemini) voice compatible with the
   * current filter (gender + advanced gating) when advanced TTS is enabled, otherwise the first
   * compatible standard voice. This is what makes an advanced voice the default.
   */
  defaultVoice() {
    // Seed a voice coherent with the current (default/restored) avatar gender so the initial
    // pairing stays consistent; afterwards, voice changes drive the avatar.
    const pool = this.compatibleVoices;
    const avatarGender = getAvatarEntry(this.selectedAvatar)?.gender;
    const genderPool = avatarGender === AIAvatarGender.MALE || avatarGender === AIAvatarGender.FEMALE ? pool.filter(v => v.gender === avatarGender) : pool;
    const base = genderPool.length ? genderPool : pool;
    const advanced = this.advancedTtsEnabled ? base.find(v => v.advanced) : undefined;
    return (advanced ?? base[0] ?? LIST_OF_VOICES[0]).voice;
  }
  /**
   * Voice = source of truth for gender: whenever a gendered voice is selected, make sure the
   * avatar matches it (pick a default avatar of that gender when the current one differs).
   * Neutral / unknown voices keep the current avatar. Runs regardless of the avatar toggle so
   * the avatar we always send stays coherent with the voice.
   */
  syncAvatarToVoiceGender() {
    const g = getVoiceEntry(this.selectedVoice)?.gender;
    if (g !== AIAvatarGender.MALE && g !== AIAvatarGender.FEMALE) return;
    if (getAvatarEntry(this.selectedAvatar)?.gender === g) return;
    const next = this.lastAvatarForGender(g);
    if (next && next !== this.selectedAvatar) {
      this.selectedAvatar = next;
      localStorage.setItem(LS_PREFIX + "avatar", next);
      this.recordAvatarForGender(next);
      this.stopAnim();
    }
  }
  /**
   * The avatar to use for a gender: the LAST avatar the user picked for that gender (allow-list
   * aware), falling back to the default avatar of that gender when none was used yet.
   */
  lastAvatarForGender(g) {
    const stored = localStorage.getItem(LS_PREFIX + "avatar_" + g);
    const entry = stored ? getAvatarEntry(stored) : undefined;
    if (entry && entry.gender === g && isCustomAvatarAllowed(entry, this.avatarCustom)) {
      return stored;
    }
    return getDefaultAvatarForGender(g, this.avatarCustom);
  }
  /** Remember the given avatar as the last-used one for its gender, so switching the voice's gender restores it. */
  recordAvatarForGender(avatar) {
    const g = getAvatarEntry(avatar)?.gender;
    if (g === AIAvatarGender.MALE || g === AIAvatarGender.FEMALE) {
      localStorage.setItem(LS_PREFIX + "avatar_" + g, avatar);
    }
  }
  ensureVoiceMatchesFilter() {
    const available = this.compatibleVoices;
    if (available.length === 0) return;
    if (!available.find(v => v.voice === this.selectedVoice)) {
      // The current voice no longer fits the filter (e.g. the gender changed after re-enabling the
      // avatar). Always re-pick an advanced (Gemini) voice of the new gender when advanced TTS is
      // enabled: the previous pick is invalid anyway, so the advanced default must win over the first
      // standard voice.
      const advanced = this.advancedTtsEnabled ? available.find(v => v.advanced) : undefined;
      this.selectedVoice = (advanced ?? available[0]).voice;
    }
  }
  // === Preview styles ===
  get previewFrameStyle() {
    const bg = getBackgroundEntry(this.selectedBackground);
    return bg ? {
      backgroundImage: `url(${bg.url})`
    } : {};
  }
  get avatarStaticStyle() {
    return {
      backgroundImage: `url(${getAvatarThumbnailUrl(this.selectedAvatar)})`
    };
  }
  get currentAvatarAnimUrl() {
    return getAvatarAnimUrl(this.selectedAvatar);
  }
  // === Validation ===
  get canValidate() {
    if (!this.selectedVoice) return false;
    if (this.isAvatarActive) {
      if (!this.selectedAvatar || !this.selectedBackground) return false;
    }
    // Explainer template is required in the modes that include it.
    if (this.showExplainerBlock && !this.selectedTemplateKey) return false;
    return true;
  }
  // === Lifecycle ===
  mounted() {
    const durations = [this.$t('aiSpeachGenerator.options.durations.short').toString(), this.$t('aiSpeachGenerator.options.durations.medium').toString(), this.$t('aiSpeachGenerator.options.durations.long').toString()];
    this.listOfDuration = durations.map(d => ({
      value: d,
      label: d
    }));
    this.durationSelected = this.duration || this.listOfDuration[0].value;
    this.loadFromStorage();
    // Seed the per-gender memory with the initial avatar, then align: avatar active → the avatar
    // drives the voice list; no avatar → the voice drives the avatar's gender.
    this.recordAvatarForGender(this.selectedAvatar);
    if (this.isAvatarActive) {
      this.ensureVoiceMatchesFilter();
    } else {
      this.syncAvatarToVoiceGender();
    }
    // If the current mode already shows the explainer block, center its selected template.
    this.scrollToSelectedTemplate('auto');
  }
  loadFromStorage() {
    // contentMode is now owned by the Options step (passed in as a prop).
    const av = localStorage.getItem(LS_PREFIX + "avatar");
    const avEntry = av ? getAvatarEntry(av) : undefined;
    // Only restore a stored avatar when it is still allowed (custom avatars are gated by AI_AVATAR_CUSTOM).
    if (avEntry && isCustomAvatarAllowed(avEntry, this.avatarCustom)) {
      this.selectedAvatar = av;
    }
    // Safety: if the (default or restored) avatar is a custom one not allowed by the conf, fall back to
    // the first available avatar so a disallowed avatar (Dana/Andy) can never end up in the generation.
    const currentEntry = getAvatarEntry(this.selectedAvatar);
    if (!currentEntry || !isCustomAvatarAllowed(currentEntry, this.avatarCustom)) {
      const firstAllowed = getAvailableAvatars(this.avatarCustom)[0];
      if (firstAllowed) {
        this.selectedAvatar = firstAllowed.avatar;
      }
    }
    const bg = localStorage.getItem(LS_PREFIX + "background");
    if (bg && LIST_OF_BACKGROUND.find(b => b.background === bg)) {
      this.selectedBackground = bg;
    }
    // The voice is intentionally NOT restored from storage: an advanced (Gemini) voice must be the
    // default every time the generator opens — and again whenever the gender changes — so persisting
    // a previous (standard) pick would defeat that.
    this.selectedVoice = this.defaultVoice();
    const imgStyle = localStorage.getItem(LS_PREFIX + "imageStyle");
    if (imgStyle && LIST_OF_IMAGE_STYLES.find(s => s.value === imgStyle)) {
      this.selectedImageStyle = imgStyle;
    }
    const tplKey = localStorage.getItem(LS_PREFIX + "template");
    if (tplKey && LIST_OF_VISUAL_TEMPLATES.find(t => t.key === tplKey)) {
      this.selectedTemplateKey = tplKey;
    }
    // Safety net for advanced-TTS gating (the seeded default is already gender-coherent
    // with the avatar); the avatar is then re-synced to the voice by the caller.
    this.ensureVoiceMatchesFilter();
  }
  // === Event handlers ===
  onUseAvatarChange(value) {
    this.useAvatar = value;
    if (value) {
      // Avatar now active → the avatar drives the voice list (filter to its gender).
      this.ensureVoiceMatchesFilter();
    } else {
      this.stopAnim();
      // No avatar now → the voice drives the avatar's gender.
      this.syncAvatarToVoiceGender();
    }
  }
  onAvatarChange(value) {
    this.selectedAvatar = value;
    localStorage.setItem(LS_PREFIX + "avatar", value);
    // Remember this as the last avatar used for its gender (restored when it comes back in no-avatar mode).
    this.recordAvatarForGender(value);
    // Reset animation so the new avatar's static thumbnail shows.
    this.stopAnim();
    // The avatar drives the voice: a new avatar gender re-filters the voice list.
    this.ensureVoiceMatchesFilter();
  }
  onBackgroundChange(value) {
    this.selectedBackground = value;
    localStorage.setItem(LS_PREFIX + "background", value);
  }
  onVoiceChange(value) {
    this.stopVoicePreview();
    this.selectedVoice = value;
    // With no avatar, the voice drives the avatar's gender (the always-sent avatar stays
    // coherent). When an avatar is active the voice list is already gender-filtered.
    if (!this.isAvatarActive) {
      this.syncAvatarToVoiceGender();
    }
  }
  /** Play/stop a pre-rendered sample of the selected voice (same-origin endpoint === 302 to the CDN MP3). */
  toggleVoicePreview() {
    if (this.previewPlaying) {
      this.stopVoicePreview();
      return;
    }
    if (!this.selectedVoice) {
      return;
    }
    const entry = LIST_OF_VOICES.find(v => v.voice === this.selectedVoice);
    const provider = entry?.provider || 'MICROSOFT';
    const audio = new Audio(`/recorder/aiSpeachGenerator/voicePreview?voiceId=${encodeURIComponent(this.selectedVoice)}&provider=${provider}`);
    audio.onended = () => this.stopVoicePreview();
    audio.onerror = () => this.stopVoicePreview();
    this.previewAudio = audio;
    this.previewPlaying = true;
    audio.play().catch(() => this.stopVoicePreview());
  }
  stopVoicePreview() {
    if (this.previewAudio) {
      this.previewAudio.pause();
      this.previewAudio = null;
    }
    this.previewPlaying = false;
    // The avatar preview plays the anim alongside the voice === when the voice
    // stops (e.g. the sample ended), stop the animation too. stopAnim() sets
    // isPlayingAnim=false before re-entering here, so this never recurses.
    if (this.isPlayingAnim) {
      this.stopAnim();
    }
  }
  beforeDestroy() {
    this.stopVoicePreview();
  }
  onImageStyleChange(value) {
    this.selectedImageStyle = value;
    localStorage.setItem(LS_PREFIX + "imageStyle", value);
  }
  scrollCarousel(direction) {
    const el = this.$refs.carousel;
    if (!el) return;
    // Scroll by roughly two card widths so the user visibly advances.
    el.scrollBy({
      left: direction * 460,
      behavior: 'smooth'
    });
  }
  /** Bring the selected template card into view (centered) when the explainer block appears. */
  onExplainerBlockShown(shown) {
    if (shown) {
      this.scrollToSelectedTemplate();
    }
  }
  scrollToSelectedTemplate(behavior = 'smooth') {
    this.$nextTick(() => {
      const carousel = this.$refs.carousel;
      if (!carousel) return;
      const selected = carousel.querySelector('.templateCard.selected');
      if (!selected) return;
      // Center the selected card in the carousel viewport.
      const left = selected.offsetLeft - (carousel.clientWidth - selected.clientWidth) / 2;
      carousel.scrollTo({
        left: Math.max(0, left),
        behavior
      });
    });
  }
  /**
   * Picking a video explainer template only records the choice === it does NOT
   * touch the useAvatar toggle nor the global image style. The template's
   * imageStyleValue is applied ONLY to EXPLAINER subchapters at generation time
   * (see SUB_CHAPTER_TYPE_CONFIG + createAndSaveWeetInitiator). Non-EXPLAINER
   * subchapters keep the image style picked in the Image Style block.
   */
  onTemplateSelect(key) {
    this.selectedTemplateKey = key;
    localStorage.setItem(LS_PREFIX + "template", key);
  }
  togglePreview() {
    if (this.isPlayingAnim) {
      this.stopAnim();
    } else {
      // Reset any prior voice BEFORE marking the anim as playing === stopVoicePreview
      // now also stops the anim, so calling it after would immediately kill it.
      this.stopVoicePreview();
      this.isPlayingAnim = true;
      // The avatar preview also plays a sample of the selected voice.
      this.toggleVoicePreview();
      // Force play from the beginning on next tick (once <video> becomes visible).
      this.$nextTick(() => {
        const v = this.$refs.animVideo;
        if (v) {
          v.currentTime = 0;
          v.play().catch(() => {});
        }
      });
    }
  }
  stopAnim() {
    this.isPlayingAnim = false;
    this.stopVoicePreview();
    const v = this.$refs.animVideo;
    if (v) {
      v.pause();
      v.currentTime = 0;
    }
  }
  onValidate() {
    if (!this.canValidate) return;
    const avatarActive = this.isAvatarActive;
    const explainerEnabled = this.showExplainerBlock;
    const fullExplainer = this.contentMode === ContentMode.FULL_EXPLAINER;
    this.$emit('validate', {
      useAvatar: avatarActive,
      // Always send a coherent avatar (gender-matched to the voice) — never null — so the
      // generation always has one available, even when the avatar block is toggled off.
      avatar: this.selectedAvatar,
      // Background is kept even without an avatar: speacher_front reuses the
      // last one it was given, so sending null would leave it on whatever the
      // previous generation set.
      background: this.selectedBackground,
      voice: this.selectedVoice,
      imageStyle: this.selectedImageStyle,
      // Only send the template key in the modes that use a video explainer.
      visualTemplate: explainerEnabled ? this.selectedTemplateKey : null,
      explainerEnabled,
      quizEnabled: this.quizEnabled,
      annotationsEnabled: this.annotationsEnabled,
      // Full Video Explainer === the LLM forces every subchapter to EXPLAINER.
      fullExplainer
    });
  }
  onBack() {
    this.$emit('back');
  }
};
__decorate([Prop({
  default: false
})], AIStyleStep.prototype, "advancedTtsEnabled", void 0);
__decorate([Prop({
  default: ContentMode.FULL_SLIDE
})], AIStyleStep.prototype, "contentMode", void 0);
__decorate([Prop({
  default: SlideGenerationMode.ENHANCED
})], AIStyleStep.prototype, "generationMode", void 0);
__decorate([Prop({
  default: ''
})], AIStyleStep.prototype, "duration", void 0);
__decorate([Prop({
  default: ''
})], AIStyleStep.prototype, "specificPrompt", void 0);
__decorate([Prop({
  default: true
})], AIStyleStep.prototype, "allowReorder", void 0);
__decorate([Prop({
  default: ''
})], AIStyleStep.prototype, "avatarCustom", void 0);
__decorate([Watch('contentMode')], AIStyleStep.prototype, "onContentModeChanged", null);
__decorate([Watch('showExplainerBlock')], AIStyleStep.prototype, "onExplainerBlockShown", null);
AIStyleStep = __decorate([Component({
  emits: ['validate', 'back', 'contentMode', 'generationMode', 'durationChange', 'specificPrompt', 'allowReorder'],
  components: {
    AiCreditsToolTip,
    Icon,
    StandardButton,
    WSelect,
    VoiceSelectorModal,
    WInput,
    WCheckbox
  }
})], AIStyleStep);
export default AIStyleStep;